import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";

const ENCRYPTION_KEY =
  process.env.REACT_APP_PERSIST_KEY || "mySuperSecretKey123!";

export const persistAssessment = {
  key: "assessment",
  storage,
  whitelist: ["currentAssessment", "lessonAssessment"],
  transforms: [
    encryptTransform({
      secretKey: ENCRYPTION_KEY,
      onError: (err) => {
        console.error("Erreur de déchiffrement pesistAssessment :", err);
      },
    }),
  ],
};
